import classNames from "classnames";
import ReactTooltip from "react-tooltip";
import s from "./styles.module.scss";
import React from "react";
import { Link } from "react-router-dom";
import { cutText } from "../../../utils/string";

const MenuLink = ({ Icon, children, active, tooltip, collapsed, color, className, ...rest }) => {
  return (
    <Link
      className={classNames(
        s.menuTab,
        {
          [s.active]: active,
          [s.collapsed]: collapsed,
        },
        className,
      )}
      {...rest}
    >
      <div className={s.icon} data-tip data-for={tooltip}>
        {Icon && <Icon />}
      </div>
      {collapsed && (
        <ReactTooltip
          id={tooltip}
          className="tooltip"
          effect="solid"
          type="light"
          place="right"
          border={true}
          borderColor={color}
          multiline={false}
        >
          {tooltip}
        </ReactTooltip>
      )}

      {children && <div className={s.link}>{cutText(children)}</div>}
    </Link>
  );
};

export default MenuLink;
